import React, { useState, useEffect } from 'react';

import { FormError } from '../../../../components/form';
import { Button } from '../../../../components/general';

import { EVENT_TYPE_SAMPLE } from '../../../../constants';

import { getEventTypes } from '../../../../services/api/events';

import { ProjectType } from '../../../../types';

interface Props {
  type?: string;
  changeType: (newType: ProjectType) => void;
  error?: string;
}

const ProjectTypeSelector: React.FC<Props> = (props) => {
  const { type, changeType, error } = props;

  const [recType, setRecType] = useState<ProjectType | null>(null);
  const [typeOptions, setTypeOptions] = useState([]);

  const volumeOptions: { text: string; recType: ProjectType }[] = [
    { text: '15', recType: 'videographer' },
    { text: '150', recType: 'videographer' },
    { text: '1,500', recType: 'brand' },
    { text: '15,000 – 150,000', recType: 'brand' },
  ];

  useEffect(() => {
    const onMount = async () => {
      const options = await getEventTypes();
      setTypeOptions(
        options.filter((o: ProjectType) => o !== EVENT_TYPE_SAMPLE),
      );
    };

    onMount();
  }, []);

  return (
    <div>
      {!type ? (
        <div className="flex flex-col gap-4">
          <div>How many people are attending your event?</div>

          <div className="flex flex-wrap gap-4">
            {volumeOptions.map((option, index) => (
              <Button
                colour="grey-outline-salmon"
                className="w-[calc((100%_-_1rem)_/_2)] sm:w-[calc((100%_-_3rem)_/_4)]"
                onClick={() => {
                  sessionStorage.setItem('attendees', option.text);
                  changeType(option.recType);
                  setRecType(option.recType);
                }}
                key={index}
              >
                ~ {option.text}
              </Button>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {recType && (
            <div>
              Based on the given attendee number, we recommend you to use{' '}
              <b>{recType}</b> type.
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-10">
            {typeOptions.map((option, index) => (
              <Button
                colour={type === option ? 'pink' : 'grey-outline-salmon'}
                className="w-full sm:w-1/2 capitalize"
                onClick={() => changeType(option)}
                key={index}
              >
                {option}
              </Button>
            ))}
          </div>
        </div>
      )}

      <FormError errMsg={error} />
    </div>
  );
};

export default ProjectTypeSelector;
